// style imports
import { Label } from "Component";
import "./Radio.css";

const Radio = ({ children, value, name, checked, onChange }) => {
  return (
    <div className="mues_row_flex mues_column_gap_4 radio_container mues_pointer" onClick={()=> onChange(value)} id={name}>
      <div className="radio_button_circle mues_row_center">
        <div className={`${checked ? "checked" : ""}`}></div>
      </div>
      <Label className={"mues_pointer"}>{children}</Label>
    </div>
  );
};

export default Radio;
